import classNames from "utils/preact/class-names"

import { useTranslation } from "../components/Translation"
import css from "../style.module.scss"

export function SocialAuthSuccess() {
  const t = useTranslation()

  return (
    <div className={css.content}>
      <p
        className={classNames({
          [css["text-medium"]]: true,
          [css["text-center"]]: true,
          [css["font-medium"]]: true,
          [css["spacer-bottom"]]: true,
        })}
      >
        {t("social_auth_success")}
      </p>
      <div className={css.loader} />
    </div>
  )
}
